import { removeTheseProps } from '@/utils';
import { styled, Stack, StackProps } from '@mui/material';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import CloudOffIcon from '@mui/icons-material/CloudOff';

type StatusProps = StackProps & {
  status: string;
  useIcon?: true;
};

const StyledStatus = styled(Stack, {
  shouldForwardProp: removeTheseProps<StatusProps>('status'),
})<StatusProps>(({ status, theme }) => ({
  width: 109,
  padding: '5px 6px',
  color:
    status === 'active'
      ? theme.palette.green.main
      : status === 'low credits'
        ? theme.palette.yellow.main
        : status === 'sold out'
          ? theme.palette.skyBlue100.main
          : theme.palette.red300.main,
  borderRadius: 4,
  backgroundColor:
    status === 'active'
      ? theme.palette.green100.main
      : status === 'low credits'
        ? theme.palette.yellow.main + '20'
        : status === 'sold out'
          ? theme.palette.skyBlue100.main + '20'
          : theme.palette.red100.main,
  textTransform: 'capitalize',
  fontSize: 12,
  alignItems: 'center',
}));

export const Status = ({ status, useIcon }: StatusProps) => {
  return (
    // <Stack direction="row">
    <StyledStatus status={status} direction="row" gap={1}>
      {useIcon ? (
        status === 'active' ? (
          <TaskAltIcon sx={{ fontSize: 16 }} />
        ) : status === 'deactivated' ? (
          <CloudOffIcon sx={{ fontSize: 16 }} />
        ) : (
          <DoubleArrowIcon sx={{ fontSize: 16, rotate: '90deg' }} />
        )
      ) : (
        ''
      )}
      {status}
    </StyledStatus>
    // </Stack>
  );
};
